import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringInclude',
  standalone: true,
})
export class StringIncludePipe implements PipeTransform {
  transform(value: string | undefined, element: string): boolean {
    return (value || '').includes(element);
  }
}
